import React, {CSSProperties} from "react";

import "./Tag.scss";

export default function Tag(props: IProp) {
    return (
        <div className="Tag" style={{background: props.color, color: props.textColor, ...props.style}}>
            <span className="text">{props.text}</span>
        </div>
    )
}

interface IProp {
    text: string;
    color?: string;
    textColor?: string;
    style?: CSSProperties;
}